const SvgAlaramClock = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.16602 2.5L1.66602 5M18.3327 5L15.8327 2.5M4.99935 15.8333L3.33268 17.5M14.9993 15.8333L16.666 17.5M9.99935 7.5V10.8333L11.666 12.5M9.99935 17.5C11.7675 17.5 13.4632 16.7976 14.7134 15.5474C15.9636 14.2971 16.666 12.6014 16.666 10.8333C16.666 9.06522 15.9636 7.36953 14.7134 6.11929C13.4632 4.86905 11.7675 4.16667 9.99935 4.16667C8.23124 4.16667 6.53555 4.86905 5.2853 6.11929C4.03506 7.36953 3.33268 9.06522 3.33268 10.8333C3.33268 12.6014 4.03506 14.2971 5.2853 15.5474C6.53555 16.7976 8.23124 17.5 9.99935 17.5Z"
      stroke="#444CE7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAlaramClock
